/*
 * NOTICE:  All information contained herein is, and remains the property of Power Settlements Consulting and Software, LLC.
 * The intellectual and technical concepts contained herein are proprietary to Power Settlements Consulting and Software, LLC
 * and are protected by trade secret or copyright law. Dissemination or reproduction of this material, in whole or in part,
 * is strictly forbidden without the prior written permission of Power Settlements Consulting and Software, LLC.
 * Copyright (c) Power Settlements Consulting and Software, LLC. All rights reserved.
*/

import moment from 'moment';
import { tradeDateRange, stateAllocYears } from '@/components/Ciso/BaseStore/CisoConfigs';
import { CISO_SAMC_API } from '@/api';

const state = {
  tableData: [],
  searchFiltersConfig: {
    allocationType: {
      label: 'Allocation Type',
      value: 'JLS',
      type: 'select',
      options: [
        { value: 'JLS', label: 'JLS' },
        { value: 'SCHEDULE', label: 'SCHEDULE' },
        { value: 'SE', label: 'SE' },
        { value: 'ST', label: 'ST' },
        { value: 'RESOURCE', label: 'RESOURCE' },
      ],
    },
    tradeDateRange,
    stateAllocYears,
  },
};

const actions = {
  async fetchStateAllocationRef({ commit }, args) {
    const params = {
      allocationType: args.allocationTypeSelected,
      year: args.stateAllocYearsSelected,
      startDate: moment(args.tradeDateRangeSelected[0]).toISOString(),
      endDate: moment(args.tradeDateRangeSelected[1]).toISOString(),
    };
    try {
      const { data: { data } } = await CISO_SAMC_API.get('/state-alloc-ref', { params });
      data.forEach((obj) => {
        if (obj.tradeDate === null) {
          obj.tradeDate = obj.year;
        } else {
          obj.tradeDate = moment(obj.tradeDate).utc().format('MM/DD/YYYY');
        }
      });
      commit('setTableData', data);
    } catch (err) {
      this.$notify('Failed to Load Loaded Statement', 'error');
    }
  },
};

const mutations = {
  setTableData(state, data) {
    state.tableData = data;
  },
  reset(state) {
    state.tableData = [];
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};